var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Event-Based-Process",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Publish",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00561561,5 C8.03942246,5 8.07222039,5.00883297 8.1009482,5.02516082 L8.14060468,5.05510649 L11.9443223,8.80684614 C11.9988577,8.86045899 12.0148734,8.94106277 11.9855054,9.01115836 C11.9631979,9.06345329 11.9185795,9.10225605 11.865171,9.118389 L11.8093332,9.12662543 L9.71205127,9.12662543 L9.71205127,13.8125571 C9.71205127,13.8987781 9.6527299,13.9714661 9.57205002,13.9933004 L9.52138278,14 L6.47077623,14 C6.38307146,14 6.30913263,13.9416822 6.28692259,13.8623672 L6.28010773,13.8125571 L6.28010773,9.126643 L4.19083361,9.126643 C4.1138119,9.126643 4.04440478,9.08090251 4.01466142,9.01080692 C3.99235391,8.95822204 3.99599698,8.89974608 4.02221987,8.85116932 L4.05584453,8.80647712 L7.87062653,5.05473747 C7.90646513,5.01987418 7.95490533,5 8.00561561,5 Z M13,1 L13,3 L3,3 L3,1 L13,1 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublish);
export default __webpack_public_path__ + "static/media/publish.629a19492c9c9b1c962872fd66054d71.svg";
export { ForwardRef as ReactComponent };